export default __webpack_public_path__ + "static/media/icon-search.2fcbd1b7.svg";